import React from 'react';
import { Redirect } from 'react-router';
import styles from './TakerAppHashRouteRedirect.scss';

const getSlugFromHash = hash => hash.replace(/^(#\/)/, '');

const TakerAppHashRouteRedirect = () => {
  // supporting old taker url format @sinslav
  const slug = getSlugFromHash(location.hash);
  return slug ? (
    <Redirect to={slug} />
  ) : (
    <h2 className={styles.errorMessage}>Page not found</h2>
  );
};

export default TakerAppHashRouteRedirect;
